import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { contratoService, type ContratoFilters } from '@/services/contrato.service'
import type { Contrato } from '@/types/database'

export function useContratos(filters: ContratoFilters = {}) {
    return useQuery({
        queryKey: ['contratos', filters],
        queryFn: () => contratoService.list(filters),
    })
}

export function useContrato(id: string | null) {
    return useQuery({
        queryKey: ['contrato', id],
        queryFn: () => contratoService.getById(id!),
        enabled: !!id,
    })
}

export function useCreateContrato() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: Partial<Contrato>) => contratoService.create(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['contratos'] }),
    })
}

export function useCancelContrato() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => contratoService.cancel(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['contratos'] })
            qc.invalidateQueries({ queryKey: ['contrato'] })
        },
    })
}

export function usePortalContracting() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: {
            associado_id: string
            servico_id: string
            servico_ids?: string[]
            tenant_id: string
            dia_vencimento: number
            valor_mensal: number
            valor_adesao: number
            adesao_pro_rata: boolean
            termo_aceite_em: string | null
            assinatura_digital?: any
        }) => contratoService.checkoutPortal(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['contratos'] }),
    })
}
